import { Injector } from '@angular/core';

export class ComponentData {
  constructor(
    public id: string,
    public text: string,
    public componentType: any,
    public customInjector: Injector,
    public jsonTypeName: string,
    public componentInputs?: Record<string, unknown>
  ) {}
}

export enum ControlType {
  TextArea = 1,
  CheckBox = 5,
  ComboBox = 2,
  TextBox = 0,
  AutoCompleteTextBox = 3,
  RichTextBox = 4,
  Document = 6,
  Label = 7,
  Hyperlink = 8,
  CheckBoxList = 9,
  Lookup = 10,
  RadioButton = 11,
  DateTimePicker = 12,
  DatePicker = 13,
  ItemSelector = 14,
}

export class ModelData {
  constructor(
    public id: string,
    public modelType: any,
    public customInjector: Injector
  ) {}
}
